import React from "react";
import { I18nextProvider } from "react-i18next";
import { ShiftStateProvider } from "./context";
import ShiftForm from "./ShiftForm";
import i18n from "../i18n";

const ShiftFormPage = ({ organization }) => (
  <ShiftStateProvider>
    <I18nextProvider i18n={i18n}>
      <ShiftForm id={organization} />
    </I18nextProvider>
  </ShiftStateProvider>
);

export default ShiftFormPage;
